import { AbstractService } from '@uniqoders/sdk';

export default class PageService extends AbstractService {
  /**
   * Retrieve paginated CMS pages for an agency
   */
  public listCmsPages(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/pages', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single CMS page
   */
  public getCmsPage(agency: string, cmsPageId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/pages/{cmsPageId}', { agency, cmsPageId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS page
   */
  public createCmsPage(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/pages', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS page
   */
  public updateCmsPage(agency: string, cmsPageId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/pages/{cmsPageId}', { agency, cmsPageId }),
      data,
    });
  }

  /**
   * Delete a CMS page
   */
  public deleteCmsPage(agency: string, cmsPageId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/pages/{cmsPageId}', { agency, cmsPageId }),
    });
  }

  /**
   * Publish or unpublish a CMS page
   */
  public publishCmsPage(
    agency: string,
    cmsPageId: number,
    data: { is_public: boolean },
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/pages/{cmsPageId}/publish', { agency, cmsPageId }),
      data,
    });
  }

  /**
   * Upload a featured image via multipart form-data
   */
  public uploadFeaturedImage(agency: string, cmsPageId: number, data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/pages/{cmsPageId}/upload-featured', { agency, cmsPageId }),
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

